import React from 'react';
import PropTypes from 'prop-types';
import './DemoControls.scss';
import AmplifyButton from '@amplify/amplify-button';
import { DEMO_TYPES } from '../../../../../constants/reading/DemoModeConstants';

const DemoControls = ({
    demoType,
    setDemoType,
    resetTour,
    visitedTourSteps,
    isGuidedTourOn,
    isAllResultsFetched,
}) => {
    const inTourClassName = isGuidedTourOn ? 'in-tour' : '';
    const startTourButtonPrefix = visitedTourSteps.length === 1 ? 'Turn On' : 'Resume';
    const toggleDemoTypeButtonText = `${
        isGuidedTourOn ? 'Turn Off' : startTourButtonPrefix
    } Guidance`;

    const toggleGuidance = () => {
        let newDemoType;

        if (demoType === DEMO_TYPES.DEFAULT || demoType !== DEMO_TYPES.GUIDED_TOUR) {
            newDemoType = DEMO_TYPES.GUIDED_TOUR;
        } else if (demoType === DEMO_TYPES.GUIDED_TOUR || demoType !== DEMO_TYPES.SELF_EXPLORE) {
            newDemoType = DEMO_TYPES.SELF_EXPLORE;
        }
        setDemoType(newDemoType);
    };
    const onResetTour = () => {
        resetTour();
    };

    return (
        <>
            <div className={`${inTourClassName} `} id="demo-controls">
                <div className="demo-controls-btns">
                    <AmplifyButton
                        color="secondary"
                        extraClassnames={inTourClassName}
                        onClick={toggleGuidance}
                        disabled={!isAllResultsFetched}
                        oval
                    >
                        {toggleDemoTypeButtonText}
                    </AmplifyButton>
                    {isGuidedTourOn && (
                        <AmplifyButton
                            color="secondary"
                            extraClassnames="in-tour tour-start-over-button"
                            onClick={onResetTour}
                            disabled={!isAllResultsFetched}
                            oval
                        >
                            Start Over
                        </AmplifyButton>
                    )}
                </div>
            </div>
        </>
    );
};
DemoControls.defaultProps = {
    demoType: '',
    setDemoType: () => {},
    resetTour: () => {},
    visitedTourSteps: [],
    isGuidedTourOn: false,
    isAllResultsFetched: false,
};

DemoControls.propTypes = {
    demoType: PropTypes.string,
    setDemoType: PropTypes.func,
    resetTour: PropTypes.func,
    visitedTourSteps: PropTypes.array,
    isGuidedTourOn: PropTypes.bool,
    isAllResultsFetched: PropTypes.bool,
};
export default DemoControls;
